import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 28 27"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#DA9081",
      "fill-opacity": ".09",
      d: "M12.676 1.12a1.167 1.167 0 0 1 2.092 0L18 7.665c.17.344.498.583.877.638l7.229 1.057a1.167 1.167 0 0 1 .645 1.99l-5.229 5.092c-.275.268-.4.655-.335 1.034l1.233 7.193a1.167 1.167 0 0 1-1.693 1.23L14.265 22.5a1.167 1.167 0 0 0-1.086 0L6.717 25.9a1.167 1.167 0 0 1-1.693-1.23l1.233-7.194a1.167 1.167 0 0 0-.335-1.032L.692 11.35a1.167 1.167 0 0 1 .646-1.99l7.229-1.057c.38-.055.707-.294.877-.638l3.232-6.547Z"
    }, null, -1)
  ]))]))
}
export default { render: render }